export default __webpack_public_path__ + "static/media/img23.21f66235.jpg";